/**
 * Chrome iOS / Safari JSC and in-page translators (Google Translate) recurse
 * until RangeError: Maximum call stack size exceeded. Those stacks point at
 * the HTML document, not our Vite bundle (GLOWCARD-71, GLOWCARD-6M).
 *
 * Real app recursion still reports frames under /build/assets/.
 *
 * @param {{ exception?: { values?: Array<{ type?: string, value?: string, stacktrace?: { frames?: Array<{ filename?: string }> } }> } }} event
 * @param {unknown} originalException
 * @returns {boolean}
 */
export function isUnactionableCallStackOverflow(event, originalException) {
    const errorMessage = originalException instanceof Error ? originalException.message : String(originalException ?? '');
    const exception = event?.exception?.values?.[0];
    const combined = `${errorMessage} ${exception?.value ?? ''} ${exception?.type ?? ''}`;

    if (!combined.includes('Maximum call stack size exceeded')) {
        return false;
    }

    const frames = exception?.stacktrace?.frames ?? [];

    if (frames.length === 0) {
        return true;
    }

    return !frames.some((frame) => {
        const filename = frame?.filename ?? '';

        return filename.includes('/build/assets/') || filename.includes('/resources/js/');
    });
}
